<template>
  <div>
    <TopNav>
      <template v-slot:barmenu>
        <v-btn v-if="showExperimentalFeatures" @click="$router.replace('/discover')" v-ripple="{ class: 'primary--text' }" class="rounded-0" text>
          <v-icon>mdi-magnify</v-icon>
          <div>
            Discover
            <div class="text-caption red--text text--lighten-4" style="font-size: 0.6rem; text-transform: lowercase;">under construction</div>
          </div>
        </v-btn>
        <v-btn v-ripple="{ class: 'primary--text' }" class="rounded-0 active" text>
          <v-icon>mdi-view-dashboard-variant</v-icon>
          Decisions
        </v-btn>
      </template>
      <template v-slot:drawermenu v-if="showExperimentalFeatures">
        <v-list-item @click="$router.replace('/discover')">
          <v-list-item-icon>
            <v-icon>mdi-magnify</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              <div>
                Discover
                <div class="text-caption red--text text--lighten-4" style="font-size: 0.6rem; text-transform: lowercase;">under construction</div>
              </div>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </TopNav>
    <PageBar title="Your Decisions">
      <template v-slot:actions:add>
        <NewDecisionDialog @onConfirm="newDecision" :defaultName="defaultNewDecisionName" />
      </template>
    </PageBar>
    <v-container v-if="loadingDecisions" class="px-0">
      <v-row align="start" justify="center">
        <v-col cols="12">
          <v-row>
            <v-col>
              <v-skeleton-loader
                class="mx-auto"
                min-width="350"
                type="card"
              ></v-skeleton-loader>
            </v-col>
            <v-col>
              <v-skeleton-loader
                class="mx-auto"
                min-width="350"
                type="card"
              ></v-skeleton-loader>
            </v-col>
            <v-col>
              <v-skeleton-loader
                class="mx-auto"
                min-width="350"
                type="card"
              ></v-skeleton-loader>
            </v-col>
          </v-row>
        </v-col>
        <!-- <v-col cols="4" class="d-none d-md-flex">
        </v-col> -->
      </v-row>
    </v-container>
    <v-container v-else class="px-0">
      <v-row align="start" justify="center" no-gutter dense>
        <!-- <v-col cols="12" md="8"> -->
        <v-col cols="12">
          <v-row align="center">
            <template v-for="(decision, index) in decisions">
              <v-col :key="decision.id" :class="{'first-decision': index === 0, 'padded-col': $vuetify.breakpoint.mobile}">
                <DecisionCard
                  :decisionId="decision.id"
                  :currentUserIsOwner="decision.owner === currentUser.uid"
                  :name="decision.name"
                  :imgSrc="decision.imgSrc"
                  :optionsCount="decision.optionsCount"
                  :shortListCount="decision.shortListCount"
                  :hasChosen="decision.chosenOption ? true : false"
                  :ownerPhotoUrl="currentUser.photoUrl"
                  :ownerDisplayName="currentUser.displayName"
                  :ownerEmail="currentUser.email"
                  :members="decision.members"
                  @onOpen="openDecision(decision.id)"
                />
              </v-col>
            </template>
          </v-row>
        </v-col>
        <!-- <v-col cols="4" class="d-none d-md-flex">
          <v-container fluid>
            <div>Filters: todo</div>
            <v-divider></v-divider>
            <v-container class="grey lighten-5">
              <v-row>
                TODO: Other peoples decision feed
              </v-row>
            </v-container>
          </v-container>
        </v-col> -->
      </v-row>
    </v-container>
    <v-tour name="decisionsTour" :steps="decisionsIntrosteps" :callbacks="introTourCallbacks" :options="introOptions"></v-tour>
  </div>
</template>

<script>
import Constants from '../constants.json'
// This import loads the firebase namespace along with all its type information.
import * as firebase from 'firebase/app'
// Load the auth feature into the firebase namespace.
import 'firebase/auth'
import axios from 'axios'

import { mapState, mapGetters } from 'vuex'

// @ is an alias to /src
import TopNav from '@/components/TopNav.vue'
import PageBar from '@/components/IndexPageBar.vue'
import DecisionCard from '@/components/DecisionCard.vue'
import NewDecisionDialog from '@/components/NewDecisionDialog.vue'

// Veux types
import * as DecisionsTypes from '../store/types/decisions'

// Mixins
//import boilerplatMixin from '@/mixins/BoilerplateLoader.js'

export default {
  name: 'Decisions',
  //mixins: [boilerplatMixin],
  components: {
    TopNav,
    PageBar,
    DecisionCard,
    NewDecisionDialog
  },
  data () {
    return {
      // decisions: [],
      creating: false,
      currentUser: firebase.auth().currentUser,
      // loadingDecisions: false,
      shareInProgress: false,
      defaultNewDecisionName: null,
      introOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: 'Skip tour',
          buttonPrevious: 'Previous',
          buttonNext: 'Next',
          buttonStop: 'Got it!'
        }
      },
      decisionsIntrosteps: [
        {
          target: '.logo-container',  // We're using document.querySelector() under the hood
          content: `<h3>Welcome to Decidedly</h3> Take this tour to see how Decidedly helps you organize, compare and share so you can choose better!`
        },
        {
          target: '.section-intro-target',  // We're using document.querySelector() under the hood
          content: `In this section you can keep track of all your Decisions and share them with others!`
        },
        {
          target: '#add-decision-action-button',
          content: 'Click here to create new Decisions. Each Decision helps you keep track of everything you need to make a great choice.',
          params: {
            highlight: true
          }
        }
      ],
      introTourCallbacks: {
        onPreviousStep: this.tourPreviousStepCallback,
        onNextStep: this.tourNextStepCallback,
        onSkip: this.tourSkippedCallback,
        onFinish: this.tourFinishedCallback
      }
    }
  },
  computed: {
    ...mapState({
      loadingDecisions: state => state.decisions.fetchingStatus,
      lastFetchedTime: state => state.decisions.lastFetchedTime,
      showExperimentalFeatures: state => state.user.showExperimentalFeatures,
      hideIntroPreference: state => state.user.hideIntro,
      prefsLoaded: state => state.user.loaded,
    }),
    ...mapGetters('decisions', {
      decisions: 'sorted',
    }),
    hideIntro () {
      return this.$vuetify.breakpoint.mobile || this.hideIntroPreference
    },
  },
  mounted: function () {
    this.currentUser = firebase.auth().currentUser
    // this.$store.dispatch('user/loadPreferences')
    // this.$store.dispatch('decisions/loadAllDecisions')
    this.fetchUserDecisions()
    if (!this.hideIntro && this.prefsLoaded) { // If prefs are not loaded then tour will be triggered by a watch of the hideIntro state
      this.$tours['decisionsTour'].start()
    }
  },
  watch: {
    hideIntro: function (shouldHide) {
      // console.log(`Hide intro changed ${shouldHide} mutations = ${mutation}`)
      if (shouldHide === true) {
        this.$tours['decisionsTour'].stop()
      }
      else if (shouldHide === false) {
        this.$tours['decisionsTour'].start()
      }
    }
  },
  methods: {
    tourPreviousStepCallback: function (currentStep) {
      // When there are no decisions yet, the tour should help the user create their first one
      // The new decision dialog could be open to help the user in this case. So close it on this previous step action
      if (currentStep === 2 && this.decisions.length === 0) {
        this.$store.commit(`decisions/${DecisionsTypes.MUTATION_NEW_DECISION_DIALOG}`, false)
      }
    },
    tourNextStepCallback: function (/*currentStep*/) {
      // When there are no decisions yet, the tour should help the user create their first one
      // So open a new decision dialog on this next step
      // if (currentStep === 1 && this.decisions.length === 0) {
      //   this.defaultNewDecisionName = 'Example Decision'
      //   this.$store.commit(`decisions/${DecisionsTypes.MUTATION_NEW_DECISION_DIALOG}`, true)
      // }
    },
    tourFinishedCallback: function () {
      // When this part of the tour is finished we should create a new example decision if there is not one already
      // if (this.decisions.length === 0) {
      //   this.newDecision({name: this.defaultNewDecisionName})
      // }
      this.$store.commit(`decisions/${DecisionsTypes.MUTATION_NEW_DECISION_DIALOG}`, true)

    },
    tourSkippedCallback: function () {
      this.$store.dispatch('user/updateHideIntro', true)
    },
    newDecision: async function (newDecisionData, addDefaultCriteria) {
      let shouldAddDefaultCriteria = addDefaultCriteria
      if (typeof addDefaultCriteria === 'undefined') {
        shouldAddDefaultCriteria = true
      }
      if (this.creating) {
        return
      }
      this.creating = true
      const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
      const postNewDecisionsURL = `${Constants.API_BASE_PATH}/decisions`
      const newDecisionBody = {name: newDecisionData.name, addDefaults: shouldAddDefaultCriteria}
      const res = await axios.post(postNewDecisionsURL, newDecisionBody, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      })

      this.creating = false
      if (res && res.status === 200 && res.data && res.data.decisionId) {
        // Mutate decisions list

        const newDecisionsURL = `${Constants.API_BASE_PATH}/decisions/${res.data.decisionId}`
        const newDecisionRes = await axios.get(newDecisionsURL, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        })
        if (newDecisionRes && newDecisionRes.status === 200 && newDecisionRes.data) {

          // Set the decision taxon if one was selected
          if (newDecisionData.categoryData) {
            const postCategoryURL = `${Constants.API_BASE_PATH}/decisions/${res.data.decisionId}/category`
            await axios.post(postCategoryURL, newDecisionData.categoryData, {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
              }
            })

          }

          this.$store.commit(`decisions/${DecisionsTypes.MUTATION_ADD_DECISION}`, newDecisionRes.data)
          this.$router.replace(`/decisions/${newDecisionRes.data.id}`)

          // Reset default name
          this.defaultNewDecisionName = null
        }
      } else {
        // console.log(`Unexpected response ${JSON.stringify(res)}`)
        alert('Unexpected response creating new decision')
      }
    },
    openDecision: function (decisionId) {
      this.$router.replace(`/decisions/${decisionId}`)
    },
    /*shareDecision: async function (shareData) {
      const sharedDecisionId = shareData.decisionId
      if (this.shareInProgress || !sharedDecisionId) {
        return
      }
      this.shareInProgress = true
      const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
      const postNewDecisionMemberURL = `${Constants.API_BASE_PATH}/decisions/${sharedDecisionId}/members`
      const res = await axios.post(postNewDecisionMemberURL, shareData, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      this.shareInProgress = false
      if (res && res.status === 200 && res.data) {

        if (res.data.status === 'success' && res.data.newMemberData) {
          console.log (`New Member added ${JSON.stringify(res.data.newMemberData)}`)
        } else if (res.data.status === 'not found') {
          console.log ('That user is not in the system')
        }

      } else {
        console.log(`Unexpected response ${JSON.stringify(res)}`)
        alert('Unexpected response creating new decision')
      }
    },*/
    // fetchUserDecisions: async function () {
    //   this.loadingDecisions = true
    //   const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
    //   const openDecisionsURL = `${Constants.API_BASE_PATH}/decisions`
    //   const res = await axios.get(openDecisionsURL, {
    //     headers: {
    //       'Content-Type': 'application/json',
    //       'Authorization': `Bearer ${token}`,
    //     }
    //   })
    //
    //   this.decisions = res.data
    //   // sort
    //   this.decisions.sort((a, b) => {
    //     const aSeconds = a.createdAt._seconds
    //     const bSeconds = b.createdAt._seconds
    //     return bSeconds - aSeconds
    //   })
    //   this.loadingDecisions = false
    // }
    fetchUserDecisions: async function () {
      // Load all decisions into the store unless the decision list is already loaded in our store
      if (!this.lastFetchedTime) {
        this.$store.dispatch('decisions/loadAllDecisions')
      }
    }
  }
}
</script>

<!--
Example fetch using Bearer
async function fetchFromAPI() {

  const user = auth.currentUser;
  const token = user && (await user.getIdToken());

  const res = await fetch(url, {
    methodL 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  return res.json();
}
-->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.add-decision-button {
  top: 80px;
}
.comparison-list {
  display: flex;
  justify-content: space-around;
}
.padded-col {
  padding: 20px 25px;
}
</style>
